import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { type ContractStepTermsProps } from '@/common/types/contract';
import { StringXSmall } from '@/components/Typography/Typography';

import { ContractTerms } from '../ContractTerms/ContractTerms';

interface Props extends ContractStepTermsProps {
  isContractExpired: boolean;
}

const ContractStepTerms: FC<Props> = ({
  isContractExpired,
  step,
  classNames,
  ...termsProps
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn('flex flex-col items-center gap-2', classNames?.wrapper)}
    >
      <StringXSmall className="!leading-1.2">
        {t('Step {{step}}', { step })}
      </StringXSmall>
      <ContractTerms
        {...termsProps}
        hasContractExpired={isContractExpired}
        className={classNames?.list}
      />
    </div>
  );
};

export { ContractStepTerms };
